import { useSyncExternalStore } from 'react'
import { toastStore, dismissToast } from '../store/toasts'
import { useKeyboardOpen } from '../lib/viewport'

export function Toasts() {
  const toasts = useSyncExternalStore(toastStore.subscribe, toastStore.get)
  // Above the tab bar; while typing, at the top of the screen (they don't ride the keyboard).
  const kb = useKeyboardOpen()
  if (!toasts.length) return null
  return (
    <div
      className="pointer-events-none fixed inset-x-0 z-50 flex flex-col items-start gap-2 px-4 md:items-center"
      style={kb ? { top: 'calc(var(--vv-top, 0px) + var(--safe-t) + 0.75rem)' } : { bottom: 'calc(var(--bar-top) + 0.75rem)' }}
      data-toasts={kb ? 'top' : 'bottom'}
      aria-live="polite"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className="toast pointer-events-auto flex w-full max-w-md items-center gap-3 rounded-xl bg-fg py-2.5 pr-2 pl-4 text-sm text-bg shadow-lg md:w-auto md:min-w-[18rem]"
          role="status"
        >
          <span className="min-w-0 flex-1">
            <span className="block truncate">{t.message}</span>
            {t.detail && <span className="block truncate text-xs opacity-70">{t.detail}</span>}
          </span>
          {t.action && (
            <button
              type="button"
              className="rounded-lg px-3 py-1 font-semibold hover:bg-white/10"
              onClick={() => {
                dismissToast(t.id)
                t.action!.run()
              }}
            >
              {t.action.label}
            </button>
          )}
        </div>
      ))}
    </div>
  )
}
